"use strict";

import gsap from 'gsap';
///GSAP///
//Burger menu animation with greensock / gsap
var burger = $(".burger"),
    burgeritem1 = $(".burger__item--1"),
    burgeritem2 = $(".burger__item--2"),
    burgeritem3 = $(".burger__item--3"),
    speed = 0.10;

//instantiate  timeline
var tl = new TimelineLite({paused:true}); //pause default

//collapse Menu
tl.to(burgeritem1, speed, {top:14, ease:Quint.easeOut}, "label--1") 
  .to(burgeritem3, speed, {top: -10, ease:Quint.easeOut}, "label--1")

//rotate all items
.to(burgeritem3, speed, {opacity: 0, scale: 0.5, ease:Quint.easeOut})
.to(burgeritem1, speed, {rotation: -45, ease:Quint.easeOut})
.to(burgeritem2, speed, {rotation: 45, ease:Quint.easeOut})

// play timeline on click, reverse animation if active
burger.click(function() {
    $(this).toggleClass('active__burger');

    if ( $(this).hasClass("active__burger") ) {
        tl.play(); 
    }  
    else {
        tl.reverse(); 
    }
});



var section__un = document.querySelector(".menu__el--un");
var section__deux = document.querySelector(".menu__el--deux");
var section__trois = document.querySelector(".menu__el--trois");
var section__quatre = document.querySelector(".menu__el--quatre");
var section__cinq = document.querySelector(".menu__el--cinq");
var contenu__un = document.querySelector(".contenu__el--un");
var contenu__deux = document.querySelector(".contenu__el--deux");
var contenu__trois = document.querySelector(".contenu__el--trois");
var contenu__quatre = document.querySelector(".contenu__el--quatre");
var contenu__cinq = document.querySelector(".contenu__el--cinq");
var sections = document.querySelectorAll(".menu__el");
var contenus = document.querySelectorAll(".contenu__el");


var rectangles__anima = document.querySelectorAll(".rectangle");
var rectangles__transi = document.querySelectorAll(".rectangle__follow");

var burger__bouton = document.querySelector(".burger");
var section__cliquer = "trois";




section__un.addEventListener(("click"),(e)=>{
    document.body.classList.add("frozen");
    section__un.classList.add("open__un");
    section__un.classList.add("active");
    section__cliquer = "un";
})
section__deux.addEventListener(("click"),(e)=>{
    document.body.classList.add("frozen");
    section__deux.classList.add("open__deux");
    section__deux.classList.add("active");
    section__cliquer = "deux";
})
section__trois.addEventListener(("click"),(e)=>{
    document.body.classList.add("frozen");
    section__trois.classList.add("open__trois");
    section__trois.classList.add("active");
    section__cliquer = "trois";
    document.body.setAttribute("data-etat","open");
})
section__quatre.addEventListener(("click"),(e)=>{
    section__quatre.classList.add("open__quatre");
    section__quatre.classList.add("active");
    section__cliquer = "quatre";
})
section__cinq.addEventListener(("click"),(e)=>{
    document.body.classList.add("frozen");
    section__cinq.classList.add("open__cinq");
    section__cinq.classList.add("active");
    section__cliquer = "cinq";
})

for(let i = 0; i<sections.length;i++){
    sections[i].addEventListener(("click"),(e)=>{
        burger.toggleClass('active__burger');
    
        if ( burger.hasClass("active__burger") ) {
            tl.play(); 
        }  
        else {
            tl.reverse(); 
        }
    })
}

section__un.addEventListener(("animationend"),(e)=>{
    section__un.classList.remove("close__un");
    document.body.classList.remove("frozen");
    if(section__un.classList.contains("open__un")){
        contenu__un.classList.remove('hidden');
        rectangles__anima[0].classList.add("animation");
        rectangles__transi[0].classList.add("transition");
        setTimeout(()=>{      
            rectangles__anima[0].classList.remove("animation");
            rectangles__transi[0].classList.remove("transition");
        },1500);
        rectangles__anima[0].classList.remove("animation__sortie");
        rectangles__transi[0].classList.remove("transition__sortie");
    }
})
section__deux.addEventListener(("animationend"),(e)=>{
    section__deux.classList.remove("close__deux");
    document.body.classList.remove("frozen");
    if(section__deux.classList.contains("open__deux")){
        contenu__deux.classList.remove('hidden');  
        rectangles__anima[1].classList.add("animation");
        rectangles__transi[1].classList.add("transition");
        setTimeout(()=>{      
            rectangles__anima[1].classList.remove("animation");
            rectangles__transi[1].classList.remove("transition");
        },1500);
        rectangles__anima[1].classList.remove("animation__sortie");
        rectangles__transi[1].classList.remove("transition__sortie");
    }
})
section__trois.addEventListener(("animationend"),(e)=>{
        section__trois.classList.remove("close__trois");
        document.body.classList.remove("frozen");
        if(section__trois.classList.contains("open__trois")){
            contenu__trois.classList.remove('hidden');
            rectangles__anima[2].classList.add("animation");
            rectangles__transi[2].classList.add("transition");
            setTimeout(()=>{      
                rectangles__anima[2].classList.remove("animation");
                rectangles__transi[2].classList.remove("transition");
            },1500);
        }     
        rectangles__anima[2].classList.remove("animation__sortie");
        rectangles__transi[2].classList.remove("transition__sortie");

})
section__quatre.addEventListener(("animationend"),(e)=>{
    section__quatre.classList.remove("close__quatre");
    document.body.classList.remove("frozen");
    if(section__quatre.classList.contains("open__quatre")){
        contenu__quatre.classList.remove('hidden');  
        rectangles__anima[3].classList.add("animation");
        rectangles__transi[3].classList.add("transition");
        setTimeout(()=>{      
            rectangles__anima[3].classList.remove("animation");
            rectangles__transi[3].classList.remove("transition");
        },1500);
        rectangles__anima[3].classList.remove("animation__sortie");
        rectangles__transi[3].classList.remove("transition__sortie");
    }
})
section__cinq.addEventListener(("animationend"),(e)=>{
    section__cinq.classList.remove("close__cinq");
    document.body.classList.remove("frozen");
    if(section__cinq.classList.contains("open__cinq")){
        contenu__cinq.classList.remove('hidden');  
        rectangles__anima[4].classList.add("animation");
        rectangles__transi[4].classList.add("transition");
        setTimeout(()=>{      
            rectangles__anima[4].classList.remove("animation");
            rectangles__transi[4].classList.remove("transition");
        },1500);
        rectangles__anima[4].classList.remove("animation__sortie");
        rectangles__transi[4].classList.remove("transition__sortie");
    }
})

burger__bouton.addEventListener(("click"),(e)=>{
    if(section__cliquer === "trois"){
        if(!sections[2].classList.contains("active")){
            sections[2].classList.add("open__trois");
            sections[2].classList.add('active');
        }
        else{
            rectangles__anima[2].classList.add("animation__sortie");
            rectangles__transi[2].classList.add("transition__sortie"); 
            setTimeout(()=>{      
                rectangles__transi[2].scrollTop=0;
                sections[2].classList.add("close__trois");
                document.body.classList.add("frozen");
                sections[2].classList.remove("open__trois");
                sections[2].classList.remove('active');    
                contenu__trois.classList.add('hidden');
            },1300);
        }
    }else{
        for(let i=0; i<sections.length; i++){
            let cibleSection = sections[i].getAttribute("data-section");
            if(cibleSection === section__cliquer && sections[i].classList.contains("active")){
                rectangles__anima[i].classList.add("animation__sortie");
                rectangles__transi[i].classList.add("transition__sortie");
                setTimeout (()=>{   
                    sections[i].classList.add("close__"+cibleSection);
                    document.body.classList.add("frozen");
                    sections[i].classList.remove("open__"+cibleSection);
                    sections[i].classList.remove('active');     
                    rectangles__transi[i].scrollTop=0;
                    for(let i=0; i<contenus.length;i++){
                        if(contenus[i].getAttribute("data-contenu") === cibleSection){
                            contenus[i].classList.add("hidden");
                        }
                    }
                },1300);
            }
            else if(cibleSection === section__cliquer && !sections[i].classList.contains("active")){
                document.body.classList.add("frozen");
                sections[i].classList.add("open__"+cibleSection);
                sections[i].classList.add('active');
            }
            if(sections[i].getAttribute("data-section") === "cinq"){
                videoTrailer.classList.remove('resize');
                videoTrailerBtn.classList.remove('hidden');
                videoTrailerFilter.classList.remove('hidden');
                videoTrailer.currentTime =0;
            }
        }
    }
});


//___videoTrailer

var videoTrailerBtn = document.querySelector(".button--playVideo");
var videoTrailer = document.querySelector(".contenu__el--cinq .video");
var videoTrailerFilter = document.querySelector(".contenu__el--cinq .videoFiltre");
videoTrailerBtn.addEventListener(("click"),(e)=>{
    videoTrailer.classList.add('resize');
    videoTrailerBtn.classList.add('hidden');
    videoTrailerFilter.classList.add('hidden');
    videoTrailer.currentTime =0;

})




